import { cn } from "helper/cn";

import React from "react";

import { ICONS } from "../../../assets/icons/index";

const EditDelete = ({
  onEditClick,
  onDeleteClick,
  onTryClick,
  onActivateClick,
  showActivate = true,
  showEdit = true,
  showDelete = true,
  tryAgain = true,
  cancel = true,
  rootClassName = "",
}) => {
  return (
    <div className={cn("w-full flex-column p-10", rootClassName)}>
      {showActivate && (
        <div className="w-full py-1">
          <div
            className={`w-full h-10 px-2.5 py-1 flex-row align-center justify-center  pointer rounded-md hover:bg-[var(--new-primary-bg)] ${
              !showDelete ? "" : ""
            }`}
            onClick={onActivateClick}
          >
            <img src={ICONS?.crmTagEdit} alt="" className="" />
            <span className="pl-10  text-[var(--contentText)] font14px-500 ">
              Activate
            </span>
          </div>
          {showActivate && <div className=" tags-border mt-1" />}
        </div>
      )}
      {showEdit && (
        <div className="w-full">
          <div
            className={`w-full h-10 px-2.5 py-1 flex-row align-start justify-start  pointer rounded-md hover:bg-[var(--a)]  ${
              showDelete ? "tags-border" : ""
            }`}
            onClick={onEditClick}
          >
            <img src={ICONS?.crmTagEdit} alt="" className="" />
            <span className="pl-10  text-[var(--contentText)] font14px-500">
              Edit
            </span>
          </div>
        </div>
      )}
      {showDelete && (
        <div className="w-full">
          <div
            className={`w-full h-10 px-2.5 py-1 flex-row align-center justify-center  pointer rounded-md hover:bg-[var(--BG-50)] ${
              cancel ? "" : ""
            }`}
            onClick={onDeleteClick}
          >
            <img src={ICONS?.RedDeleteIcon} alt="" className="" />
            <span className=" text-[--fontRed] font14px-500">Delete</span>
          </div>
        </div>
      )}
      {tryAgain && (
        <div className="w-full py-1">
          <div
            className={`w-full h-11 px-2.5 py-1.5 flex-row align-center justify-center  pointer rounded-md hover:bg-[var(--BG-50)] ${
              cancel ? "tags-border" : ""
            }`}
            onClick={onTryClick}
          >
            <img src={ICONS?.crmTagEdit} alt="" className="" />
            <span className="pl-10  text-[var(--contentText)] font14px-500">
              Try Again
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditDelete;
